export default "__VITE_ASSET__BvGlCvWM__"